<template>
  <header>
    <div class="my_top bc_F2F2F2 site_min_w">
      <div class="site_content d_flex justify_content_sb fz12 c_1A1A1A">

        <div class="d_flex">
          <!-- <div class="div_2 d_flex">
            <span>您好！</span>
            <span>欢迎来到{{ siteName }}</span>
          </div> -->

          <div v-if="!isLogin" class="d_flex div_3">
            <router-link class="span_4" to="/login">登录</router-link>
            <span class="span_3" />
            <span class="span_4" @click="onRegisterClick">注册</span>
          </div>

          <div v-else class="div_3">
            <router-link to="/account/setting" class="c_EF3946">{{ userinfo.username }}</router-link>
            <span class="span_5 cursor_pointer c_1A1A1A" @click="doLogout('/')">[退出登录]</span>
          </div>
        </div>

        <div class="d_flex ">

          <!-- <span class="span_4">
            <el-popover
              title=""
              trigger="hover"
              placement="bottom"
            >
              <div slot="">
                <img :src="require('@/assets/images/qYU8J9N5UVJV2Fnt.png')" style="width:150px" alt="">
              </div>
              <div slot="reference">
                <div>
                  <span class="">小程序</span>
                </div>
              </div>
            </el-popover>
          </span> -->
          <span class="span_4">
            <el-popover
              title=""
              trigger="hover"
              placement="bottom"
            >
              <div slot="">
                <img :src="require('@/assets/images/publicNumber.jpg')" style="width:150px" alt="">
              </div>
              <div slot="reference">
                <div>
                  <span class="">公众号</span>
                </div>
              </div>
            </el-popover>
          </span>
          <span class="span_3" />
          <span  @click="jumpToHtml" class="span_4" >地合网</span>
          <!-- <span class="span_4"><a href="https://dihe.cn/" target="_blank">地合网</a></span> -->
          <span class="span_3" />

          <router-link v-if="cmsProblemNode" class="span_4" :to="`${cmsProblemNode.nodeModel.route}/${cmsProblemNode.children[0].id}`">帮助中心</router-link>

          <span class="span_3" />
          <span style="font-size:13px;">咨询热线：{{ siteInfo.hotline }}</span>
        </div>

        <!-- <div class="d_flex ">
          <div>
            <span>今天是：</span>
            <span class="span_1">{{ y }}年{{ M }}月{{ d }}日</span>
            <span>星期{{ T[x] }}</span>
          </div>

          <div v-if="weatherRes" class="div_1">
            <span class="span_1">{{ weatherRes.city }}</span>
            <span
              class="span_2"
            >{{ weatherRes.tem_night }}-{{ weatherRes.tem_day }}°</span>
            <span>{{ weatherRes.wea }}</span>
          </div>
        </div> -->

      </div>
    </div>
    <!-- <el-dialog
      title="系统暂停服务公告"
      :visible.sync="dialogVisible"
      width="35%"
      :before-close="handleClose"
      top="20vh"
      center
    >
      <ul v-infinite-scroll="load" class="infinite-list" style="overflow:auto;height: 260px;">
        <span>尊敬的各位用户：<br><br><br>
          &nbsp;&nbsp;&nbsp;&nbsp;感谢您对我们平台网站的支持与信任。<br><br>
          &nbsp;&nbsp;&nbsp;&nbsp;按照我市政数局的相关要求，为加强网络安全防护，以及给您提供更优质的服务， 经上级主管部<br>门同意，从即日起至2024年8月20日进行官网域名变更，将旧官网访问域名：https://www.sgnccq.com（韶关市农村产权交易平台） 替换成新官网访问政务域名：nccq.nyj.sg.gov.cn（韶关市农村产权交易平台）。替换过程中，官网可能存在不能访问或不稳定的情况，给您带来的不便敬请谅解。

          <br><br><br><br> &nbsp;&nbsp;&nbsp;&nbsp;如有疑问需要帮助，您可通过拨打0751-6083668前台联系。谢谢！

        </span></ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">我已阅读并知悉</el-button>
      </span>
    </el-dialog> -->
  </header>
</template>

<script type="text/javascript">
import { mapGetters, mapActions } from 'vuex'
import request from '@/utils/request'
import bus from '@/utils/bus'
export default {
  components: {
  },
  data() {
    return {
      y: '', // 年
      M: '', // 月
      d: '', // 日
      x: '', // 星期几
      T: ['日', '一', '二', '三', '四', '五', '六'],
      weatherRes: null,
      dialogVisible: true
    }
  },
  computed: {
    ...mapGetters(['siteName', 'siteInfo', 'isLogin', 'cmsProblemNode', 'userinfo', 'oss_pub_domain'])
  },
  watch: {
  },
  created() {
    this.y = new Date().getFullYear()
    this.M = new Date().getMonth() + 1
    this.d = new Date().getDate()
    this.x = new Date().getDay()

    setTimeout(() => {
      this.initProblemNode()
    }, 0)
    // this.getWeather()
  },
  methods: {
    ...mapActions({
      doLogout: 'user/doLogout',
      initProblemNode: 'cache/initProblemNode'
    }),
    jumpToHtml() {
      // 方式1：新标签页打开
      window.open('/skip.html', '_blank');

      // 方式2：当前页跳转
      // window.location.href = './your-file.html';
    },
    // 获取天气信息
    async getWeather() {
      // 获取ip地址
      const res = await request({
        url: '/cityjson?ie=utf-8'
      })
      window.eval(res)

      // 根据ip获取天气数据
      const data = await request({
        url: '/free/day',
        params: {
          appid: 45112884,
          appsecret: 'IWzX78Pb',
          vue: 1,
          ip: returnCitySN['cip']
        }
      })
      this.weatherRes = data
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    // 注册点击 click
    onRegisterClick() {
      this.$router.push({
        query: {
          returnUrl: '/'
        },
        path: '/register'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.my_top {
  padding: 10px 0;
  .span_1 {
    margin: 0 20px 0 0;
  }
  .span_2 {
    margin: 0 4px 0 0;
    color: #f37958;
  }
  .span_3{
    width: 1px;
    height: 15px;
    margin: 0 15px;
    background-color: #ccc;
  }
  .span_4{
    &:hover{
      cursor: pointer;
      text-decoration: underline;
    }
  }
  .span_5{
    margin: 0 0 0 10px;
  }
  .div_1 {
    margin: 0 0 0 80px;
  }
  .div_2 {
    color: #3084cf;
  }
  .div_3{
    margin: 0 0 0 30px;
  }
}
</style>
